import React from "react";
import { Statistic } from "antd";
import dayjs from "dayjs";
import "./index.css";

const ReferenceReservationStatistics = ({ reservationHistory }) => {
  const categorizeReservations = (reservationHistory) => {
    const today = dayjs().startOf("day"); // Start of today's date

    let pastReservations = 0;
    let todayReservations = 0;
    let futureReservations = 0;

    reservationHistory.forEach((reservation) => {
      const reservationDate = dayjs(reservation.date);

      if (reservationDate.isBefore(today)) {
        pastReservations++;
      } else if (reservationDate.isSame(today, "day")) {
        todayReservations++;
      } else {
        futureReservations++;
      }
    });

    return { pastReservations, todayReservations, futureReservations };
  };

  const { pastReservations, todayReservations, futureReservations } =
    categorizeReservations(reservationHistory);

  return (
    <div className="reference-reservations-statistics">
      <Statistic
        title={
          <p className="reference-reservations-statistics-title">Минали</p>
        }
        value={pastReservations}
        valueStyle={{ textAlign: "center", fontSize: "18px" }}
      />
      <Statistic
        valueStyle={{ textAlign: "center", fontSize: "18px" }}
        title={
          <p className="reference-reservations-statistics-title reference-reservations-statistics-today-title">
            Днес
          </p>
        }
        value={todayReservations}
      />
      <Statistic
        valueStyle={{ textAlign: "center", fontSize: "18px" }}
        title={
          <p className="reference-reservations-statistics-title">Бъдещи</p>
        }
        value={futureReservations}
      />
    </div>
  );
};

export default ReferenceReservationStatistics;
